// delimiter is disabled to prevent twitching while entering edit mode
const NUMBER_DELIMITER = ""; // Narrow No-Break Space
// const NUMBER_DELIMITER = "\u202F"; // Narrow No-Break Space

export function getNumberDisplayValue(num: string | number, delimiter = NUMBER_DELIMITER) {
  if (!delimiter) return String(num);

  if (/e/i.test(String(num))) return String(num);

  const [integerPart, decimalPart] = String(num).split(".");
  const formattedInteger =
    Number(integerPart) >= 10000
      ? integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, delimiter)
      : integerPart;

  if (decimalPart !== undefined) {
    return `${formattedInteger}.${decimalPart}`;
  }

  return formattedInteger;
}
